import {
  Bullseye,
  EmptyState,
  EmptyStateHeader,
  EmptyStateIcon,
  EmptyStateVariant,
} from '@patternfly/react-core'
import { SearchIcon } from '@patternfly/react-icons'

const Empty = () => {
  return (
    <Bullseye>
      <EmptyState variant={EmptyStateVariant.sm}>
        <EmptyStateHeader
          titleText='Nenhum alarme encontrado no período selecionado.'
          icon={<EmptyStateIcon icon={SearchIcon} />}
          headingLevel='h2'
        />
      </EmptyState>
    </Bullseye>
  )
}

export default Empty
